import { useQuery } from "@apollo/client";
import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import FinancialHighlightsQuery from "lib/queries/FinancialHighlightsQuery";
import type {
  IFinancialHighlightsQuery,
  IFinancialHighlightsQueryVariables,
} from "lib/queries/__generated__/FinancialHighlightsQuery.generated";
import { useQueryState } from "nuqs";

export default function useBrazilianHighlights() {
  const issuer = useBrazilianIssuer();

  const [filterByFinancialHighlightsId, setFilterByFinancialHighlightsId] = useQueryState("highlightId");

  const {
    data: highlightsData,
    previousData: highlightsPreviousData,
    loading,
  } = useQuery<IFinancialHighlightsQuery, IFinancialHighlightsQueryVariables>(FinancialHighlightsQuery, {
    variables: {
      issuerId: issuer._id,
      financialHighlightsId: filterByFinancialHighlightsId,
    },
  });

  const highlights = highlightsData ?? highlightsPreviousData;

  return {
    highlights,
    filterByFinancialHighlightsId,
    setFilterByFinancialHighlightsId,
    loading,
  };
}
